import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBiorhythmPhysicalIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 23.2L25.8333 4L22.3333 16.8H34L14.1666 36L17.6667 23.2H6Z",
		stroke: "#9565FD",
		strokeWidth: 2.5,
		strokeLinejoin: "round"
	})
});
export default SvgBiorhythmPhysicalIcon;
